<template>
    <div class="box">
        <h3>{{$t('profile.personal_data.basic_data')}}</h3>
        <div class="box__form">
            <div>
                <div class="control control--input">
                    <label for="name" class="control__label">{{$t('profile.personal_data.firstname')}}</label>
                    <input type="text" id="name" :placeholder="$t('profile.personal_data.enter_firstname')"
                           v-model="firstName"
                    />
                </div>
                <div class="control control--input">
                    <label for="surname" class="control__label">{{$t('profile.personal_data.lastname')}}</label>
                    <input
                        type="text"
                        id="surname"
                        :placeholder="$t('profile.personal_data.enter_lastname')"
                        v-model="lastName"
                    />
                </div>
                <div class="control control--input">
                    <label for="email" class="control__label">{{$t('profile.personal_data.email')}}</label>
                    <input
                        type="text"
                        id="email"
                        readonly
                        :placeholder="$t('profile.personal_data.enter_email')"
                        v-model="authStore.user.email"
                        style="background-color: #efefef"
                    />
                </div>
            </div>
            <div>
                <div class="control control--input">
                    <label for="phoneNumber" class="control__label">{{ $t('profile.personal_data.phone') }}</label>
                    <input
                        type="text"
                        id="phoneNumber"
                        :placeholder="$t('profile.personal_data.enter_phone')"
                        v-model="phone"
                    />
                </div>
                <div class="control control--input">
                    <label for="phoneNumber2" class="control__label">{{ $t('profile.personal_data.second_phone') }}</label>
                    <input
                        type="text"
                        id="phoneNumber2"
                        :placeholder="$t('profile.personal_data.enter_second_phone')"
                        v-model="secondPhone"
                    />
                </div>
            </div>
            <div class="buttons">
                <button
                    @click="saveBasiDataColumn"
                    class="button-outline"
                    :class="{'disabled': sendingForm}"
                    :disabled="sendingForm"
                >
                    <template v-if="!sendingForm">
                        {{ $t('profile.personal_data.update_info') }}
                    </template>
                    <template v-else>
                        {{ $t('profile.personal_data.updating_info') }}
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import authHelper from "@/helpsers/auth.helper";
import {inject, ref, watch} from "vue";
import {useAuthStore} from "@/stores/auth.store";
import UserService from "@/services/user.service";
import ApiHelper from "@/helpsers/api.helper";
import AlertHelper from "@/helpsers/alert.helper";
import {useI18n} from "vue-i18n";

export default {
    name: "PersonalData",
    setup(props) {
        const authStore = useAuthStore();
        let alert = inject('alert');
        const {t} = useI18n();
        const sendingForm = ref(false);

        const firstName = ref(authStore?.userInfo?.firstName);
        const lastName = ref(authStore?.userInfo?.lastName);
        const phone = ref(authStore?.userInfo?.phone);
        const secondPhone = ref(authStore?.userInfo?.secondPhone);

        watch(authStore,(curr,old) => {
            lastName.value = curr?.userInfo?.lastName;
            firstName.value = curr?.userInfo?.firstName;
            phone.value = curr?.userInfo?.phone;
            secondPhone.value = curr?.userInfo?.secondPhone;
        })

        function saveBasiDataColumn() {

            const data = {
                name: firstName.value,
                lastname: lastName.value,
                phone: phone.value,
                phoneSecond: secondPhone.value
            }

            sendingForm.value = true;
            axios.put(ApiHelper.getUpdateUserUrl(), data, {
                headers: authHelper.authHeader()
            }).then(response => {
                sendingForm.value = false;
                AlertHelper.show(alert, t('alert.successfully_updated_data'));
                authStore.userInfo.firstName = firstName.value;
                authStore.userInfo.lastName = lastName.value;
                authStore.userInfo.phone = phone.value;
                authStore.userInfo.secondPhone = secondPhone.value;
            }).catch(errorResponse => {
                sendingForm.value = false;
                const errorMessage = errorResponse?.response?.data?.errors?.join(' ');
                AlertHelper.show(alert, t('alert.error_during_updating_data'), errorMessage, 'error');
            })
        }

        return {
            saveBasiDataColumn,
            firstName,
            lastName,
            phone,
            secondPhone,
            authStore,
            sendingForm
        }

    }
}
</script>

<style scoped>

</style>